export const mapSteps = (response) => {
    return response.value.stepsToComplete;
};
export const mapProfileConfigs = (response) => {
    return {
        profileTabs: response.value,
        isAvailableFA: response.value.some((item) => item.key === "FinancialAssistance")
    };
};
